!(function () {
  "use strict";
  customElements.get("cart-upsell") ||
    customElements.define(
      "cart-upsell",
      class extends HTMLElement {
        constructor() {
          super();
          this.isLoading = false;
        }

        get button() {
          return this.querySelector('button');
        }

        connectedCallback() {
          const id = this.getAttribute("data-line-item-id");
          const quantity = this.getAttribute("data-line-item-quantity");
          const selling_plan = this.getAttribute("data-selling-plan-id");
          const index = this.getAttribute("data-item-index");
          this.button.addEventListener("click", (e)=>this.onButtonClick(e,id, quantity, selling_plan,index));
        }

        onButtonClick(e,id, quantity, selling_plan, index) {
          e.preventDefault();
          
          // Prevenir dobles clicks
          if (this.isLoading) return;
          
          const item = this.closest("cart-item");
          this.updateCart(
            {
              id,
              quantity,
              selling_plan,
              index,
            },
            item
          );
        }

        // Obtener las secciones que necesitan actualizarse (similar a cart.js)
        getSectionsToRender() {
          const sections = [];
          
          // Sección principal del carrito
          const mainCartItems = document.getElementById("main-cart-items");
          if (mainCartItems) {
            sections.push({
              id: "main-cart-items",
              section: mainCartItems.dataset.id,
              selector: ".js-contents",
            });
          }

          // Cart drawer si existe
          const cartDrawer = document.getElementById("CartDrawer");
          if (cartDrawer) {
            sections.push({
              id: "CartDrawer",
              section: "cart-drawer",
              selector: ".drawer-inner",
            });
          }

          // Icono del carrito
          sections.push({
            id: "cart-icon-bubble",
            section: "cart-icon-bubble",
            selector: ".shopify-section",
          });

          // Footer del carrito
          const mainCartFooter = document.getElementById("main-cart-footer");
          if (mainCartFooter) {
            sections.push({
              id: "main-cart-footer",
              section: mainCartFooter.dataset.id,
              selector: ".js-contents",
            });
          }

          return sections;
        }

        getSectionInnerHTML(html, selector) {
          return new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector(selector).innerHTML;
        }

        enableLoading() {
          this.isLoading = true;
          if (this.button) {
            this.button.disabled = true;
            this.button.classList.add('loading');
            // Guardar el texto original si no existe
            if (!this.button.dataset.originalText) {
              this.button.dataset.originalText = this.button.textContent;
            }
            this.button.textContent = 'Actualizando...';
          }
        }

        disableLoading() {
          this.isLoading = false;
          if (this.button) {
            this.button.disabled = false;
            this.button.classList.remove('loading');
            // Restaurar el texto original
            if (this.button.dataset.originalText) {
              this.button.textContent = this.button.dataset.originalText;
            }
          }
        }

        updateCart(updateData = {}, currentItem = null) {
          this.enableLoading();

          const data = {
            line: updateData.index,
            quantity: updateData.quantity,
            selling_plan: updateData.selling_plan,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname,
          };
        
          fetch('/cart/change.js', {
            method: 'post',
            headers: {'Content-Type': 'application/json', Accept: 'application/json'},
            body: JSON.stringify(data),
          })
            .then((response) => {
              return response.text();
            })
            .then((state) => {
              const parsedState = JSON.parse(state);
              console.log('Cart updated:', parsedState);

              if (parsedState.errors) {
                console.error('Cart update errors:', parsedState.errors);
                // Aquí podrías mostrar un mensaje de error al usuario
                return;
              }

              // Actualizar las secciones del carrito visualmente
              this.getSectionsToRender().forEach((section) => {
                const elementToReplace =
                  document
                    .getElementById(section.id)
                    ?.querySelector(section.selector) ||
                  document.getElementById(section.id);
                
                if (elementToReplace && parsedState.sections && parsedState.sections[section.section]) {
                  elementToReplace.innerHTML = this.getSectionInnerHTML(
                    parsedState.sections[section.section],
                    section.selector
                  );
                }
              });

              // Actualizar clases de carrito vacío
              const cartDrawerWrapper = document.querySelector("cart-drawer");
              const cartFooter = document.getElementById("main-cart-footer");
              const cartItems = document.querySelector("cart-items");

              if (cartItems) {
                cartItems.classList.toggle("is-empty", parsedState.item_count === 0);
              }
              if (cartFooter) {
                cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
              }
              if (cartDrawerWrapper) {
                cartDrawerWrapper.classList.toggle("is-empty", parsedState.item_count === 0);
              }

              // Publicar evento de actualización del carrito para que otros componentes se enteren
              if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, { 
                  source: "cart-upsell",
                  cartData: parsedState 
                });
              }

              // Reinicializar AOS si está disponible
              if (typeof AOS !== "undefined") {
                AOS.init();
              }
            })
            .catch((error) => {
              console.error('Cart update failed:', error);
              // Aquí podrías mostrar un mensaje de error al usuario
            })
            .finally(() => {
              this.disableLoading();
            });
        }
      }
    );
})();


